module.exports = __webpack_public_path__ + "static/media/hulladek logo.1b3e3412.png";


//////////////////
// WEBPACK FOOTER
// ./src/Skillset/icon/hulladek logo.png
// module id = 84
// module chunks = 0